// The shared Change or Response Type Code list (DE 670) — used by PAD03
// across transaction sets. Union of the 844's original PAD03 codes and the
// 845's additional ones, per
// reference/session/845-price-authorization-acknowledgment-status-qualifiers-txt.md.
// The home for this DE going forward: a future transaction set's PAD03
// should extend this list rather than defining its own.

import type {CodeListEntry} from './types';

export const CHANGE_OR_RESPONSE_TYPE_CODES: CodeListEntry[] = [
  {code: 'PC', label: 'Price Change'},
  {code: 'QD', label: 'Quantity Decrease'},
  {code: 'QI', label: 'Quantity Increase'},
  {code: 'DI', label: 'Delete Item(s)'},
  {code: 'RZ', label: 'Replace All Values'},
  {code: 'AI', label: 'Add Additional Item(s)'},
  {code: 'CA', label: 'Changes To Line Items'},
  {code: 'CT', label: 'Change of Dates'},
  {code: 'NC', label: 'Concurrent Item (No Change)'},
];
